export const AUXILIARY_HEATING = 49;
export const AIR_CONDITION = 38;
export const AIR_SUSPENSION = 47;
export const SPORTS_SUSPENSION = 23;
export const HAS_AMBIENT_LIGHTNING = 'hasAmbientLighting';
export const HAS_LEATHER_STEERING_WHEEL = 'hasleatherSteeringWheel';
export const HAS_SKI_BAG = 'hasSkiBag';
export const HAS_SMOKERS_PACKAGE = 'hasSmokersPackage';
export const HAS_HEATED_STEERING_WHEEL = 'hasHeatedSteeringWheel';
export const HAS_ELECTRIC_TAIL_GATE = 'hasElectricTailGate';
